import { combineReducers } from "redux";
import dateRange from "../dateRange";
import form from "./form";
import teasers from "./teasers";
import showLinks from "./showLinks";
import stat from "./stat";
import urlForm from "./urlForm";
import sort from "./sort";
import statusFilter from "./statusFilter";
import * as constants from "../../constants/teaserList";
import updateDate from "../updateDate";

const UPDATE_CONSTANTS = [
  constants.ON_TEASER_FORM_SAVE_SUCCESS,
  constants.ON_DELETE_TEASER_SUCCESS,
  constants.ON_SET_ACTIVE_SUCCESS,
  constants.ON_SET_INACTIVE_SUCCESS,
  constants.ON_TEASER_URL_CHANGE_SUCCESS
];

export default combineReducers({
  dateRange: dateRange(constants.SET_TEASER_LIST_DATE_RANGE),
  form,
  teasers,
  showLinks,
  stat,
  urlForm,
  sort,
  updateDate: updateDate(UPDATE_CONSTANTS),
  statusFilter
});
